import React from "react";
import { useTranslation } from "react-i18next";
import SEO from "components/SEO";
import DataCentreSolutionHeaderAnalyse from "./DataCentreSolutionHeaderAnalyse";
import DataCentreSolutionSectionFour from "./DataCentreSolutionSectionFour";
import DataCentreSolutionSectionThree from "./DataCentreSolutionSectionThree";
import DataCentreSolutionSectionTwo from "./DataCentreSolutionSectionTwo";
import DynamicAnalyse from "pages/DynamicAnalyse";

const SolutionPage = () => {
  const { t } = useTranslation("solutionDataCentre");
  return (
    <>
      <SEO title={t("meta.title")} description={t("meta.description")} />
      <DataCentreSolutionHeaderAnalyse />
      <DataCentreSolutionSectionTwo />
      <DataCentreSolutionSectionThree />
      <DataCentreSolutionSectionFour />
      <DynamicAnalyse page="datacentre" />
    </>
  );
};

export default SolutionPage;
